<template>
  <footer>
    <div>
      <div>
        <h2>Location</h2>
        <p>8474 Rozita Lee Ave, Suite 100</p>
        <p>Las Vegas, NV 89113</p>
      </div>
      <div class="divider" />
      <div>
        <h2>Appointment Hours</h2>
        <p>Monday - Friday</p>
        <p>9:00 AM - 6:00 PM</p>
      </div>
    </div>
  </footer>
</template>


<style lang="scss" scoped>
  footer {
    text-align: left;
    padding: 30px;
    box-sizing: border-box;
    background: url('~@/assets/images/texture.png');

    >div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 600px;
      margin: 0 auto;
      flex-direction: column;
      gap: 12px;

      >div {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }

      @media (max-width:999px) {

        p,
        h2 {
          text-align: center !important;
        }
      }

      @media (min-width:1000px) {
        flex-direction: row;
      }
    }
  }

  h2 {
    color: #FFF;
    font-family: "proxima-nova", sans-serif;
    font-size: 20px;
    font-weight: 800;
    margin:0;
    margin-bottom:6px;
    text-transform: uppercase;
  }

  p {
    color: #FFF;
    font-family: "proxima-nova", sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin:0;
  }


</style>